import React from 'react'

import EntityPage from '../components/EntityPage'
import StatusBadge from '../components/StatusBadge'
import { usePersonLabels, joinLabels } from '../api/people'

const Transport: React.FC = () => {
  const labels = usePersonLabels()

  return (
    <EntityPage
      entity="transport"
      title="🚗 Transport"
      description="Who's renting a car (and has spare seats), and how everyone else gets to the house."
      addLabel="Add transport"
      emptyHint="No transport plans yet."
      columns={[
        { key: 'member_ids', label: 'Group', render: (r) => joinLabels(labels, r.member_ids) },
        { key: 'rental', label: 'Rental car?', render: (r) => (r.rental ? '🚗 Yes' : 'No') },
        { key: 'company', label: 'Company / booking' },
        { key: 'pickup', label: 'Pickup' },
        { key: 'dropoff', label: 'Drop-off' },
        { key: 'spare_seats', label: 'Spare seats', render: (r) => (r.rental ? r.spare_seats ?? '—' : '—') },
        { key: 'no_car_plan', label: 'If no car — plan' },
        { key: 'status', label: 'Status', render: (r) => <StatusBadge status={r.status} /> },
        { key: 'notes', label: 'Notes' },
      ]}
      fields={[
        { name: 'member_ids', label: 'Group', type: 'people' },
        { name: 'rental', label: 'Renting a car?', type: 'switch' },
        { name: 'company', label: 'Company / booking', type: 'text', placeholder: 'Alamo — conf #12345' },
        { name: 'pickup', label: 'Pickup', type: 'text', placeholder: 'Sat Jan 9, 2:30 PM @ SJO' },
        { name: 'dropoff', label: 'Drop-off', type: 'text', placeholder: 'Sat Jan 16, 4:00 PM @ SJO' },
        { name: 'spare_seats', label: 'Spare seats', type: 'number', placeholder: '2' },
        {
          name: 'status', label: 'Status', type: 'select',
          options: [
            { value: 'planning', label: 'Planning' },
            { value: 'booked', label: 'Booked' },
            { value: 'needs_attention', label: 'Needs attention' },
          ],
        },
        { name: 'no_car_plan', label: 'If no car — your plan', type: 'textarea', placeholder: 'Shared shuttle SJO → house (~$50/pp)' },
        { name: 'notes', label: 'Notes', type: 'textarea' },
      ]}
      blank={{ rental: false, status: 'planning' }}
    />
  )
}

export default Transport
